import { render, staticRenderFns } from "./QuotesList.vue?vue&type=template&id=2e412310&scoped=true&"
import script from "./QuotesList.vue?vue&type=script&lang=js&"
export * from "./QuotesList.vue?vue&type=script&lang=js&"
import style0 from "./QuotesList.vue?vue&type=style&index=0&id=2e412310&lang=scss&scoped=true&"
import style1 from "./QuotesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e412310",
  null
  
)

export default component.exports